<template>
    <div 
        class="announcer-wrapper"
        @mouseenter="announce"
        @click.stop.prevent="announce"
        @keydown.enter.stop.prevent="announce"
        @keydown.space.stop.prevent="announce"
        :aria-label="computedAriaLabel"
    >
        <slot></slot>
    </div>
</template>

<script>
import adaMixin from '../js/mixins/adaMixin';

export default {
    name: 'announcer',
    mixins: [adaMixin],
    props: {
        text: {
            type: String,
            required: true
        },
        prefix: {
            type: String,
            default: ''
        },
        ariaLabel: {
            type: String,
            default: null
        }
    },
    computed: {
        computedAriaLabel() {
            return this.ariaLabel || this.text;
        }
    },
    methods: {
        announce() {
            this.setAndClearAnnouncement(this.text, this.prefix);
        }
    }
};
</script>

<style scoped>
.announcer-wrapper {
    display: inline-block;
    cursor: pointer;
}

@media (min-width: 577px) {
    .announcer-wrapper {
        cursor: default;
    }
}
</style>